import React from "react";
import FilterBar from "./FilterBar";

export default function WelcomeNavigation() {
	const ConferenceNavigationButtons = [
		// { name: "All", link: "/publications/books/all" },

		{ name: "Complete Your Profile", link: "https://app.physicianleaders.org/dashboard" },
		{ name: "Schedule an Advising Session", link: "/schedule-advising-session" },
		{ name: "Connect with Your Peers", link: "https://app.physicianleaders.org/community" },
		{ name: "Access Your Online Journals", link: "https://app.physicianleaders.org/resources/journals" },
		{ name: "Explore the Online Library", link: "https://app.physicianleaders.org/resources/library" },
		{ name: "Complete Your Leadership Assessment", link: "/assessment" },
	];

	return <FilterBar filterButtons={ConferenceNavigationButtons} hideAssessment={true} />;
}
